var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSeoIa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.54 69.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.49,36.08a3.2,3.2,0,0,0-3.15,2.57l-33.5,0v-6h17a3.22,3.22,0,1,0,0-2.57h-17V21.6h8a3.22,3.22,0,1,0,0-2.57H55.28v11H49.81V13.93a3.22,3.22,0,1,0-2.57,0V30.05H43.7V21.59H29.89V15.2a3.22,3.22,0,1,0-2.57,0v6.38H16.44a3.22,3.22,0,1,0,0,2.57l24.7,0v5.89H28a3.22,3.22,0,1,0,0,2.57l27.27,0v6l-45.06,0a3.24,3.24,0,1,0-.6,2.58h6.77v8a3.21,3.21,0,1,0,4.5,3,3.19,3.19,0,0,0-1.93-2.94v-8H41.13v5.15h-6.7a3.22,3.22,0,1,0,0,2.57H52.37v6.7a3.22,3.22,0,1,0,2.57,0v-6.7h8.31a3.22,3.22,0,1,0,0-2.57H43.69V41.19H56.55l35.38,0a3.17,3.17,0,0,0,2.55,1.29,3.22,3.22,0,1,0,0-6.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeoIa);
export default __webpack_public_path__ + "static/media/Icon-SeoIA.42602157b4bbaf8181fd77d10b2925b8.svg";
export { ForwardRef as ReactComponent };